<template>
  <wallet-form-shell>
    <div v-if="submitted">
      <wallet-form-header
        :title="title"
        :message="message"
      />
      <v-divider class="divider" />
      <h3 class="primary--text font-weight-bold">
        {{ $t('wallet.register.did-not-receive-email') }}
      </h3>
      <p class="pt-3 font-weight-bold">
        {{ $t('wallet.register.check-spam-folder-text') }}
        <a
          id="resend-email-link"
          href="#"
          @click.prevent="resendRegistrationEmail"
        >
          {{ $t('wallet.register.resend-email-link-text') }}
        </a>
      </p>
      <p class="mb-0 font-weight-bold">
        {{ $t('wallet.register.try-again-message-text') }}
        <a
          id="retry-registration-link"
          href="#"
          @click.prevent="resubmitForm"
        >
          {{ $t('wallet.register.try-again-link-text') }}
        </a>
      </p>
    </div>
    <div v-else>
      <wallet-form
        :email-address="emailAddress"
        :form-type="formType"
        :loading="loading"
        @form-submit="register"
      />
      <i18n
        path="wallet.register.footer-login-text"
        tag="p"
      >
        <router-link :to="loginRoute">
          {{
            $t('wallet.register.footer-login-link-text')
          }}
        </router-link>
      </i18n>
    </div>
  </wallet-form-shell>
</template>
<script>
import { WalletFormType } from '@/components/wallet/wallet-form-type'
import WalletFormShell from '@/components/wallet/WalletFormShell'
import WalletForm from '@/components/wallet/WalletForm'
import { mapActions } from 'vuex'
import * as actionTypes from '@/store/action-types'
import { WALLET_LOGIN_ROUTE } from '@/router/routes/route-names'
import WalletFormHeader from '@/components/wallet/WalletFormHeader'
import { NotifyMessage } from '@/service/notification/NotifyMessage'
import { NotificationService } from '@/service/notification/NotificationService'
import { WalletApi } from '@/cowboy/wallet/WalletApi'

/**
 * @property {NotificationService} NotificationService
 */
export default {
  name: 'Register',
  components: {
    WalletFormHeader,
    WalletFormShell,
    WalletForm
  },
  inject: [NotificationService.provider],
  data () {
    return {
      loading: false,
      submitted: false,
      emailAddress: null
    }
  },
  computed: {
    formType () {
      return WalletFormType.REGISTER
    },
    loginRoute () {
      return { name: WALLET_LOGIN_ROUTE }
    },
    title () {
      return this.$t('wallet.register.title-submitted')
    },
    message () {
      return this.$t('wallet.register.message-submitted', {
        email: this.emailAddress
      })
    }
  },
  methods: {
    ...mapActions({
      registerRecipient: actionTypes.REGISTER_RECIPIENT
    }),
    async register ({ emailAddress, password }) {
      this.loading = true
      this.emailAddress = emailAddress
      try {
        await this.registerRecipient({ emailAddress, password })
        this.submitted = true
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async resendRegistrationEmail () {
      if (this.emailAddress) {
        try {
          await WalletApi.resendVerificationEmail(this.emailAddress)
          this.NotificationService.push(NotifyMessage.info({
            message: this.message
          }))
        } catch (e) {
          console.error(e)
          this.NotificationService.push(NotifyMessage.error({
            message: this.$t('wallet.register.resend-email-failure-message')
          }))
        }
      }
    },
    resubmitForm () {
      this.submitted = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import 'src/assets/css/variables';
.divider {
  margin: 25px auto;
  background-color: #000000;
  width: 270px;
}
</style>
